export const TEAMS_NOT_PERMITTED_ERROR = 'TEAMS_NOT_PERMITTED_ERROR' as const;
